// src/utils/tableFilters.js

// -------- Helpers genéricos --------
export const normalize = (v) =>
  String(v ?? '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .trim()


export const isEmpty = (v) =>
  v == null ||
  (typeof v === 'string' && v.trim() === '') ||
  (Array.isArray(v) && v.length === 0)


export const toNum = (v) =>
  v === '' || v == null ? null : Number(String(v).replace(',', '.'))

export const toDate = (v) => (v ? new Date(v) : null)

// Lista de valores únicos (estilo value list do TcxGrid)
export const uniqueOptions = (items, key) => {
  const getter = typeof key === 'function' ? key : (it) => it[key]
  const set = new Set(
  (items || [])
    .map(getter)
    .filter((v) => !isEmpty(v))
  )
  return Array.from(set).sort((a, b) =>
    normalize(a).localeCompare(normalize(b))
  )
}


// -------- Engine de comparação por operadores --------
export function compareByOp(left, right, cfg, ctx = {}) {
  const L = cfg.cast === 'number' ? toNum(left) : cfg.cast === 'date' ? toDate(left) : left
  const R = Array.isArray(right)
  ? right
  : cfg.cast === 'number'
  ? toNum(right)
  : cfg.cast === 'date'
  ? toDate(right)
  : right
switch (cfg.op) {
  case 'contains':
    return normalize(L || '').includes(normalize(R || ''))
  case 'startsWith':
    return normalize(L || '').startsWith(normalize(R || ''))
  case 'eq':
    return normalize(L || '') === normalize(R || '')
  case 'in': {
    const arr = Array.isArray(R) ? R : [R]
    if (!arr.length) return true
    const leftN = normalize(L || '')
    return arr.some((val) => leftN === normalize(val))
  }
  case 'gte':
    return (L ?? -Infinity) >= (R ?? -Infinity)
  case 'lte':
    return (L ?? Infinity) <= (R ?? Infinity)
  case 'between': {
    const min = toNum(right)
    const max = toNum(ctx.other)
    if (min != null && L < min) return false
    if (max != null && L > max) return false
    return true
  }
  case 'betweenDate': {
    const d1 = toDate(right)
    const d2 = toDate(ctx.other)
    const dL = toDate(L)
    if (!dL) return false
    if (d1 && dL < d1) return false
    if (d2 && dL > d2) return false
    return true
  }
  case 'custom':
    return cfg.predicate ? cfg.predicate(L, R, { normalize, ctx }) : true
  default:
    return true
  }
}


// -------- Factory que gera a rowFilter para o <b-table> --------
export function makeRowFilter(filterConfig) {
  return function rowFilter(item, filtros) {
    return Object.keys(filterConfig).every((campo) => {
      const cfg = filterConfig[campo]
      const filtroValor = filtros[campo]
      if (isEmpty(filtroValor)) return true


      const getVal =
        typeof cfg.key === 'function' ? cfg.key : (it) => it[cfg.key || campo]
    
      const left = getVal(item)
      const other = cfg.pairWith ? filtros[cfg.pairWith] : null


      return compareByOp(left, filtroValor, cfg, { other })

    })
  }
}


// -------- (Opcional) Serializador para mandar filtros ao backend --------
export function serializeFilters(filterConfig, filtros) {
  const out = []
  for (const campo of Object.keys(filterConfig)) {
    const cfg = filterConfig[campo]
    const val = filtros[campo]
    if (isEmpty(val)) continue
      out.push({ field: cfg.key || campo, op: cfg.op, value: val, pairWith: cfg.pairWith || null, cast: cfg.cast || null })
    }
  return out
}


// WEBPACK FOOTER //
// ./src/utils/filtrosTabela.js